<template>
  <div id="add-kata">
    <form action="#" @submit.prevent="submitForm">
      <div class="form-group">
        <div class="form-group">
          <input
            type="text"
            v-model="nama"
            name="narasumber"
            value=""
            class="form-control"
            placeholder="Masukkan Narasumber"
            required
          />
        </div>
      </div>
      <div class="form-group">
        <div class="alias-input">
          <div
            v-for="(alias, index) in arrAlias"
            :key="alias"
            class="alias-input__tag"
          >
            <span v-on:click="removeAlias(index)">x</span>
            {{ alias }}
          </div>
          <input
            v-model="nama_alias"
            type="text"
            :placeholder="
              arrAlias.length > 0
                ? ''
                : 'Masukan alias, pisahkan setiap alias dengan koma'
            "
            class="alias-input__text"
            v-on:keyup.188="addAlias"
            v-on:keyup.8="removeLastAlias"
          />
        </div>
        <small class="text-muted">
          <i class="bi bi-info-circle" aria-hidden="true"></i> Tambahkan koma
          (,) setelah memasukkan satu alias
        </small>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";

$.pgNotification = notif;
export default {
  name: "modal_add_narasumber",
  data() {
    return {
      nama: this.nama_narasumber != null ? this.nama_narasumber : "",
      nama_alias: [],
      arrAlias: this.data.length > 0 ? this.data : [],
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
    };
  },
  props: {
    data: {
      type: Array,
      default: null,
    },
    nama_narasumber: {
      type: String,
      default: null,
    },
  },
  methods: {
    submitForm: function () {
      let self = this;
      if (self.nama_alias) {
        if (self.nama_alias.length > 0) {
          let newAlias = self.nama_alias.replace(",", "");
          self.arrAlias.push(newAlias);
          self.nama_alias = "";
        }
      }
      let params = {
        nama: this.nama,
        id_project: this.id_project,
        alias: this.newAlias(),
      };
      this.$store.dispatch("loading", true);
      let api = process.env.VUE_APP_API_URL + "persons-add";
      this.$http
        .post(api, params)
        .then(function (response) {
          $("#modalSlideUp").modal("hide");
          if (response.status == 200) {
            self.$store.dispatch("loading", false);
            self.$parent.$parent.getData();
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Narasumber berhasil ditambahkan!',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          } else {
            self.$store.dispatch("loading", false);
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-exclamation-circle"></i> <b>Perhatian!</b> ' +
                  response.data.status,
                position: "top",
                timeout: 5000,
                type: "warning",
              })
              .show();
          }
        })
        .catch(function (error) {
          $("#modalSlideUp").modal("hide");

          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                error.response.data.status,
              position: "top",
              timeout: 4000,
              type: "danger",
            })
            .show();
        });
    },
    addAlias: function (event) {
      event.preventDefault();
      var val = event.target.value.trim();
      if (val.length > 0) {
        let newAlias = val.replace(",", "");
        this.arrAlias.push(newAlias);
        this.nama_alias = "";
      }
    },
    removeAlias: function (index) {
      this.arrAlias.splice(index, 1);
    },
    removeLastAlias: function (event) {
      if (event.target.value.length === 0) {
        this.removeAlias(this.arrAlias.length - 1);
      }
    },
    newAlias: function () {
      let alias1 = this.data.length > 0 ? this.data : this.nama_alias;
      let vallAlias = [];
      if (alias1 != null) {
        if (alias1.length > 0 && this.arrAlias.length == 0) {
          this.arrAlias.push(alias1);
          vallAlias = this.arrAlias;
        } else {
          vallAlias = this.arrAlias;
        }
      }
      return vallAlias;
    },
  },
};
</script>
<style>
.alias-input {
  width: 100%;
  border: 1px solid #eee;
  font-size: 0.9em;
  height: 50px;
  box-sizing: border-box;
  padding: 0 10px;
  height: 100%;
}

.alias-input__tag {
  height: 30px;
  float: left;
  margin-right: 10px;
  background-color: #eee;
  margin-top: 10px;
  line-height: 30px;
  padding: 0 5px;
  border-radius: 5px;
}

.alias-input__tag > span {
  cursor: pointer;
  opacity: 0.75;
}

.alias-input__text {
  border: none;
  outline: none;
  font-size: 0.9em;
  line-height: 50px;
  background: none;
  width: 100%;
}
</style>